import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import moment from "moment-timezone";
import { useNavigate } from "react-router-dom";
import { io } from "socket.io-client";

const UserTable = ({ action, filter, dates, column, userDevice }) => {
  const [userDataList, setUserDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // const userDetails = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();

  const fetchData = (page, limit, filter, action, dates) => {
    const userDetails = JSON.parse(localStorage.getItem("user"));
    if (!userDetails || !userDetails.token) {
      navigate("/logout");
    }

    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}users-list?page=${page}&limit=${limit}`,
        {
          headers: {
            Authorization: `Bearer ${userDetails.token}`,
          },
        }
      )
      .then((response) => {
        setUserDataList(response.data.result);
        setTotalRecords(response.data.totalRecords);
      })
      .catch((error) => {
        console.error("Error fetching devices data:", error);
      });
  };

  useEffect(() => {
    fetchData(currentPage, rowsPerPage, filter, action, dates);

    // this is for local "process.env.REACT_APP_BASE_URL" and this for stage process.env.REACT_APP_BASE_URL_APP"
    // const socket = io(process.env.REACT_APP_BASE_URL_APP, {
    //   transports: ["websocket", "polling"],
    // });

    const socket = io(process.env.REACT_APP_BASE_URL_APP); //this use for prod env

    if (filter) {
      return () => {
        socket.disconnect();
      };
    }

    socket.on("deviceCreated", (data) => {
      // Clear the existing data and fetch fresh data from the server
      fetchData(currentPage, rowsPerPage, filter, action, dates); // Fetch the latest device record
    });

    return () => {
      socket.disconnect();
    };
  }, [filter, action, dates, column, currentPage, rowsPerPage]);

  useEffect(() => {
    setCurrentPage(1); // Reset to first page when filter or dates change
  }, [filter, action, dates]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleRowsPerPageChange = (newPerPage) => {
    setRowsPerPage(newPerPage);
    setCurrentPage(1);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";

    return moment.utc(dateString).format("YYYY-MM-DD hh:mm:ss A");
  };

  const userColumns = [
    {
      name: "Sr No.",
      selector: (row, index) => (currentPage - 1) * rowsPerPage + index + 1,
      width: "100px",
    },
    {
      name: "User Name",
      selector: (row) => row.name,
    },
    {
      name: "Phone",
      selector: (row) => (row && row.phone ? row.phone : "N/A"),
    },
    {
      name: "Email",
      selector: (row) => (row && row.email ? row.email : "N/A"),
    },
    {
      name: "Role",
      selector: (row) => (row.role && row.role.name ? row.role.name : "N/A"),
    },
    {
      name: "CreatedDate",
      selector: (row) => {
        if (!row.createdAt) return "";

        return formatDate(row.createdAt);
      },
    },
    {
      name: "Action",
      selector: (row) => (
        <button
          data-toggle="modal"
          data-target="#exampleModal"
          className="btn btn-primary"
          onClick={() => {
            userDevice(row._id);
          }}
        >
          Update Devices
        </button>
      ),
    },
  ];

  return (
    <div>
      <ToastContainer containerId="containerB" />
      <DataTable
        columns={userColumns}
        data={userDataList}
        pagination
        paginationServer
        paginationDefaultPage={currentPage}
        paginationTotalRows={totalRecords}
        onChangePage={handlePageChange}
        onChangeRowsPerPage={handleRowsPerPageChange}
        paginationPerPage={10} // Default rows per page
        paginationRowsPerPageOptions={[10, 25, 50, 100, 500, 1000]}
      />
    </div>
  );
};

export default UserTable;
